import { useTranslations } from "use-intl";
import { useProDriverRecord } from "@/app/ProDrivers/Drivers/Hooks/useProDriverRecord";
import { IncidentsTable } from "@/app/Incidents/Components/IncidentsTable";

export function ProDriverIncidentsScreen() {
  const t = useTranslations("incident.proDriverIncidents");
  const proDriver = useProDriverRecord();

  return (
    <div className="py-6">
      <IncidentsTable
        id="pro-driver-incidents"
        searchable={false}
        filterVariables={{ pro_driver_id: proDriver.id }}
        removedColumns={["driver"]}
        emptyState={<p className="text-sm text-gray-500">{t("empty")}</p>}
      />
    </div>
  );
}
